import { environment } from "src/environments/environment";
import { Observable } from "rxjs";
import { catchError, map } from "rxjs/operators";
import { HttpClient } from "@angular/common/http";
import { Injectable } from "@angular/core";
import { GenericRepository } from "../../generic-repository/GenericRepository";
import { ResponseModel } from "src/app/models/SharedModels/response.model";
import { CreditSales } from "src/app/models/HR/CreditSale/credit-sale";
import { ICreditSaleRepository } from "./ICreditSaleRepository";

@Injectable(
    {
        providedIn: "root"
    }
)

export class CreditSaleRepository extends GenericRepository<CreditSales> implements ICreditSaleRepository {
    url: string = environment.urlAddress;
    constructor(protected _http: HttpClient) {
        super(_http, 'api/CreditSale', environment.urlAddress);
    } 

LoadNavRec(navType: number, currentIndex: number): Observable<ResponseModel> {
        return this.GetById('NavRec/' + navType + '/' + currentIndex).pipe(map(this.extractData), catchError(this.handleError));
    }
    LoadRec(code: string): Observable<ResponseModel> {
        debugger
        return this.GetById('GetRec/' + code).pipe(map(this.extractData), catchError(this.handleError));
    }
    DeleteRec(code: string) {
        return this._http.delete(this.url + `api/CreditSale/DeleteRec/${code}`)
        .pipe(map(this.extractData), catchError(this.handleError));
    } 
    GetAll(currentPage: number, recordsPerPage: number, filterText: string): Observable<any> {
        filterText = filterText.split('/').join('~');
        if (filterText == "") {
            filterText = "|";
        }
        return this._http
            .get(this.url + 'api/CreditSale/SelectAll' + '/' + currentPage + '/' + recordsPerPage + '/' + filterText, this.httpOptions).pipe(map(this.extractData), catchError(this.handleError));
    }

    ProcessInvoice(code: string, fiscalSpanID: string): Observable<any> {
        return this.GetById('ProcessInvoice/' + code + '/' + fiscalSpanID).pipe(map(this.extractData), catchError(this.handleError));
    }

    ProcessInvoiceSearch(invoiceSearchObj: any): Observable<any> {
        return this._http.post(this.url + 'api/CreditSale/SaleInvoiceSearch', invoiceSearchObj, this.httpOptions).pipe(map(this.extractData), catchError(this.handleError));
    }

    GetLastSalePrice(productCode: string, productType: number, buyerCode: string): Observable<ResponseModel> {
        return this.GetById('/GetLastSalePrice' + '/' + productCode + '/' + productType + '/' + buyerCode).pipe(map(this.extractData), catchError(this.handleError));
    }
    SaveRec(): Observable<ResponseModel> {
        return this.PostData('/SaveRec', null).pipe(map(this.extractData), catchError(this.handleError));
    }
    CollectSaleData(item: CreditSales): Observable<ResponseModel> {
        return this.PostData('/CollectSaleData', item).pipe(map(this.extractData), catchError(this.handleError));
    }
    CollectPostingData(item: any): Observable<ResponseModel> {
        return this.PostData('/CollectPostingData', item).pipe(map(this.extractData), catchError(this.handleError));
    }
    SelectPostingAccountSetup(isAccountLinked: number): Observable<ResponseModel> {
        return this.GetById('SelectPostingAccountSetup' + '/' + isAccountLinked).pipe(map(this.extractData), catchError(this.handleError));
    }
    SelectStockBatchSerial(inwardDocument: string, godownCode: string, inwardRecordID: string): Observable<any> {
        return this.GetById('/SelectStockBatchSerial/' + inwardDocument + '/' + godownCode + '/' + inwardRecordID).pipe(map(this.extractData), catchError(this.handleError));
    }
    SelectStockBatchSerialByProduct(inwardDocument: string, productCode: string, godownCode: string, inwardRecordID: string): Observable<any> {
        return this.GetById('/SelectStockBatchSerialByProduct/' + inwardDocument + '/' + productCode + '/' + godownCode + '/' + inwardRecordID).pipe(map(this.extractData), catchError(this.handleError));
    }
    SelectBuyerInvoices(currentPage: number, recordsPerPage: number, buyerCode: string): Observable<any> {
        return this.GetById('SelectBuyerInvoices' + '/' + currentPage + '/' + recordsPerPage + '/' + buyerCode).pipe(map(this.extractData), catchError(this.handleError));
    }
    SelectGodownInvoices(currentPage: number, recordsPerPage: number, godownCode: string, DateFrom:string='',DateTo:string=''): Observable<any> {
        godownCode = godownCode!='' ? godownCode : 'null';
        return this.GetById('SelectGodownInvoices' + '/' + currentPage + '/' + recordsPerPage + '/' + godownCode+ '/' + DateFrom + '/' + DateTo).pipe(map(this.extractData), catchError(this.handleError));
    }
    GetQRCode(model: any): Observable<any> {
        return this.PostData('/GetQRCode/',model);
    }
}
